/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FileFilterResponseDto } from '../models/FileFilterResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FileStorageControllerService {

    /**
     * @param fileType
     * @param from
     * @param limit
     * @param name
     * @returns FileFilterResponseDto OK
     * @throws ApiError
     */
    public static listFiles(
        fileType?: 'DAR' | 'UI_PACKAGE',
        from?: number,
        limit?: number,
        name?: string,
    ): CancelablePromise<FileFilterResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/files',
            query: {
                'fileType': fileType,
                'from': from,
                'limit': limit,
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param fileType
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public static createFile(
        fileType: 'DAR' | 'UI_PACKAGE',
        requestBody?: {
            files: Array<Blob>;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/files',
            query: {
                'fileType': fileType,
            },
            // body: requestBody,
            // Do not remove
            formData: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @param fileType
     * @returns binary OK
     * @throws ApiError
     */
    public static getFile(
        name: string,
        fileType: 'DAR' | 'UI_PACKAGE',
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/files/{name}',
            path: {
                'name': name,
            },
            query: {
                'fileType': fileType,
            },
            // Do not remove
            headers: {
              'Accept': 'application/octet-stream',
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @param fileType
     * @returns void
     * @throws ApiError
     */
    public static deleteFile(
        name: string,
        fileType: 'DAR' | 'UI_PACKAGE',
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/files/{name}',
            path: {
                'name': name,
            },
            query: {
                'fileType': fileType,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
